import { useEffect, useMemo } from "react";

function getMagicToken() {
  try {
    return new URLSearchParams(window.location.search).get("magicToken") || "";
  } catch {
    return "";
  }
}

function buildAppUrl(token: string) {
  return token ? `zion://parent-sign-in?magicToken=${encodeURIComponent(token)}` : "zion://";
}

export function ParentSignInFallbackPage() {
  const appUrl = useMemo(() => buildAppUrl(getMagicToken()), []);

  useEffect(() => {
    if (!appUrl.includes("magicToken=")) return;
    const timer = window.setTimeout(() => {
      window.location.href = appUrl;
    }, 350);
    return () => window.clearTimeout(timer);
  }, [appUrl]);

  return (
    <div className="center">
      <div className="card" style={{ maxWidth: 560 }}>
        <h2>Open the ZCA App</h2>
        <p className="muted">
          This sign-in link is meant to open in the Zion Classical Academy mobile app.
        </p>
        <p>
          <a className="btn" href={appUrl}>Open app</a>
        </p>
        <p className="muted">
          If the app did not open, install or update the app, then request a fresh sign-in link from the app sign-in screen.
        </p>
      </div>
    </div>
  );
}
